import InstagramFeed from '@/components/InstagramFeed'
import Main from '@/components/Main'
import SEO from '@/components/SEO'
import SingleColumnContactForm from '@/components/SingleColumnContactForm'
import { FeaturedImageFragment } from '@/fragments/FeaturedImage'
import { GravityFormsFragment } from '@/fragments/GravityForms'
import styles from '@/styles/pages/_default.module.scss'
import { gql } from '@apollo/client'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot, faPhone } from '@fortawesome/sharp-solid-svg-icons'

export default function ContactPage(props) {
  // Loading state for previews
  if (props.loading) {
    return null
  }

  const metaDesc = props?.data?.page?.seo?.metaDesc
  const { title, featuredImage } = props?.data?.page ?? { title: '' }
  const gravityforms = props?.data?.gfForms?.nodes || []
  const form = gravityforms.find((node) => node.databaseId === 1)
  const seoTitle = props?.data?.page?.seo?.title

  return (
    <>
      <SEO title={seoTitle || title} description={metaDesc} imageUrl={featuredImage?.node?.sourceUrl} />

      <div className={styles.contactInfo}>
        <div className="container">
          <h2>
            You have business challenges.
            <br /> We have technology solutions.
          </h2>
          <div className={styles.contactBoxes}>
            <div className={styles.box}>
              <div className={styles.icon}>
                <FontAwesomeIcon icon={faPhone} />
              </div>
              <div>
                <h3>Call Us</h3>
                <a href="tel:3147273600">314.727.3600</a>
              </div>
            </div>
            <div className={styles.box}>
              <div className={styles.icon}>
                <FontAwesomeIcon icon={faLocationDot} />
              </div>
              <div>
                <h3>Find Us</h3>
                <a
                  target="_blank"
                  href="https://www.google.com/maps/place/Integrity+Web+Consulting/@38.6556784,-90.3035553,15z/data=!4m6!3m5!1s0x87df355465017b3b:0xba0b10b8f718b364!8m2!3d38.6556784!4d-90.3035553!16s%2Fg%2F1tf58fnq?entry=ttu&g_ep=EgoyMDI0MTIwNC4wIKXMDSoASAFQAw%3D%3D"
                  rel="noreferrer"
                >
                  6358 Delmar Blvd, Suite #444 <br /> St. Louis, MO 63130
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Main>
        {form && <SingleColumnContactForm form={form} />}
        <InstagramFeed />
      </Main>
    </>
  )
}

ContactPage.variables = ({ databaseId }, ctx) => {
  return {
    databaseId,
    asPreview: ctx?.asPreview
  }
}

ContactPage.query = gql`
  ${FeaturedImageFragment}
  ${GravityFormsFragment}
  query GetPageData($databaseId: ID!, $asPreview: Boolean = false) {
    page(id: $databaseId, idType: DATABASE_ID, asPreview: $asPreview) {
      title
      content
      seo {
        metaDesc
        title
      }
      ...FeaturedImageFragment
      innerHeroFields {
        content
        eyebrowText
        fieldGroupName
        includeForm
        title
      }
    }
    gfForms {
      nodes {
        ...GravityFormsFragment
      }
    }
  }
`
